import { useContext } from "react";
import CustomTable from "../../components/customTable/customTable.component";
import SideBar from "../../components/sideBar/sidebar.component";
import "./admin.styles.scss";
import { Options, SideBarContext } from "../../context/sidebar.context";
import { useFetchAdventures } from "../../api/queries/adventureQueries";
import { useFetchDestinations } from "../../api/queries/destinationQueries";
import moment from "moment";
import Button, {
  BUTTON_TYPE_CLASSES,
} from "../../components/button/button.component";
import { FormTypes } from "../../utils/formFactory";
import { FormContext } from "../../context/form.context";
import FormModal from "../../components/customForm/formModal.component";
import { useFetchProgrammes } from "../../api/queries/programmeQueries";
import AdminMainComponent from "./AdminMainComponent";
import AdventureAdminTable from "../../components/customTable/adventureAdminTableComponent";
import ProgrammeAdminTable from "../../components/customTable/programmeAdminTableComponent";

const AdminProgramme = () => {
  const { selectedOption } = useContext(SideBarContext);
  const { isFormOpen, setIsFormOpen, setFormType } = useContext(FormContext);

  const OpenForm = () => {
    setIsFormOpen(true);
    const form = (() => {
      switch (selectedOption) {
        case Options.Destinations:
          return FormTypes.Destination;
        case Options.Adventures:
          return FormTypes.Adventure;
        case Options.Programmes:
          return FormTypes.Programme;
        default:
          throw new Error("not implemented");
      }
    })();
    setFormType(form);
  };

  let headers = ["name", "Location", "Type", "difficulty", "max elevation"];

  if (selectedOption === Options.Adventures)
    headers.push("Start Date", "starting Price");

  headers.push("Actions");

  let hook = (() => {
    return useFetchProgrammes;
  })();

  let { data, isLoading } = hook();

  if (isLoading) return <div>is loading</div>;

  let fetchedItems = data.results;
  console.log(data)
  console.log(fetchedItems)
  return (
    <>
      <AdminMainComponent>
        <div className="admin__content-header">
          <div className="admin__content-button">
            <Button
              buttonType={BUTTON_TYPE_CLASSES.admin}
              onClick={() => OpenForm()}
            >
              &#43; add {selectedOption}
            </Button>
          </div>
          <h3 className="header__secondary--black header__secondary--sub">
            {selectedOption}
          </h3>
          <span>A list of {selectedOption}</span>
        </div>
        <div className="admin__content-table">
          <ProgrammeAdminTable
            headers={headers}
            ids={fetchedItems?.map((item) => {
              return item.id;
            })}
            actions={
              selectedOption === Options.Adventures
                ? { update: true, remove: true }
                : { image: true, update: true, remove: true }
            }
            values={fetchedItems?.map((item) => {
              const baseValues = [
                item.name,
                `${item.location}, ${item.country}`,
                item.typeLabel,
                item.difficultyLabel,
                item.maxElevation,
              ];

              if (selectedOption === Options.Adventures) {
                baseValues.push(moment(item.startDate).format("MMMM DD, YYYY"));
                baseValues.push(`${item.minimumPrice}`);
              }

              return baseValues;
            })}
            dicts={fetchedItems}
          />
        </div>
      </AdminMainComponent>
    </>
  );
};

export default AdminProgramme;
